export default {
    path: '/records',
    meta: {
        title: '能源账单',
    },
    component: r => require.ensure([], () => r(require(`./index.vue`)), `/records`),
}


// WEBPACK FOOTER //
// ./src/views/Records/router.js